export default "__VITE_ASSET__lGmvKrQ2__"